<template>
  <div>
    <b-container class="" fluid>
      <div v-if="testspacesarray.length > 0">
        <b-row>
          <b-col class="">
            <h4 class="">
              {{
                $route.query.type == "competition"
                  ? "Enter a Competition"
                  : "Enter a Testspace"
              }}
            </h4>
            <h6 style="font-style:italics">
              {{
                $route.query.type == "competition"
                  ? "Showcase your brilliance and win a Prize!"
                  : "Practice on the Go!"
              }}
            </h6>
            <b-skeleton-wrapper
              class="text-center"
              :loading="testspacesarray.length <= 0"
            >
              <template #loading>
                <b-skeleton width="100%"></b-skeleton>
              </template>
              <h6 class=""></h6>
            </b-skeleton-wrapper>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="m-0 p-1">
            <b-skeleton-wrapper
              class="text-center mt-3"
              :loading="testspacesarray.length <= 0 && !orgspacesfetched"
            >
              <template #loading>
                <b-skeleton
                  width="100%"
                  height="150px"
                  class="mt-3"
                ></b-skeleton>
                <b-skeleton
                  width="100%"
                  height="150px"
                  class="mt-3"
                ></b-skeleton>
                <b-skeleton
                  width="100%"
                  height="150px"
                  class="mt-3"
                ></b-skeleton>

                <b-skeleton
                  width="100%"
                  height="150px"
                  class="mt-3"
                ></b-skeleton>
                <b-skeleton
                  width="100%"
                  height="150px"
                  class="mt-3"
                ></b-skeleton>

                <b-skeleton
                  width="100%"
                  height="150px"
                  class="mt-3"
                ></b-skeleton>
                <b-skeleton
                  width="100%"
                  height="150px"
                  class="mt-3"
                ></b-skeleton>
                <b-skeleton
                  width="100%"
                  height="150px"
                  class="mt-3"
                ></b-skeleton>

                <b-skeleton width="100%" height="150px"></b-skeleton>
              </template>
            </b-skeleton-wrapper>

            <org-testspaces
              class="mt-2 maxres"
              @fetch="refetchSpaces()"
              v-for="(orgtestspace, index) in usetestspacesarray"
              :sn="index + 1"
              :orgtestspace="orgtestspace"
              :key="index"
              :page="pages"
              :interval="intervalnum"
            ></org-testspaces>
            <div class="text-center vmore">
              <b-row>
                <b-col class="text-left p-0 m-0">
                  <p>
                    Showing {{ intervalnum * pages - intervalnum + 1 }} -
                    {{ endnum > endss ? endss : endnum }}
                  </p>
                </b-col>
                <b-col class="text-right p-0 m-0 button-pager-group">
                  <b-button-group size="xs">
                    <b-button
                      v-for="(page, index) in ranger"
                      :key="index"
                      :page="page"
                      :class="[pages == page ? 'active-page-btn' : '']"
                      @click="newPage(page)"
                      class="ml-1 page-buttons"
                      size="xs"
                      variant="outline-dark"
                      >{{ page }}</b-button
                    >
                  </b-button-group>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
      <div  class="mt-5" v-else>
        <h1 v-if="$route.query.type == 'test'">You have not been added to a Testspace yet.</h1>
        <h1 v-if="$route.query.type == 'competition'">No Competition to Enter</h1>
      </div>
    </b-container>
  </div>
</template>

<script>
import orgTestspaces from "@/components/orgTestspaces";
import { mapState, mapActions } from "vuex";
import store from "@/store";

export default {
  components: {
    orgTestspaces
  },
  beforeRouteEnter(to, from, next) {
    if (to?.query?.type == "competition") {
      store.dispatch("dashboard/retrieveCompetitions");
    } else {
      store.dispatch("dashboard/retrieveTestspaces");
    }

    next();
  },
  data() {
    return {
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      btnrange: this.endss,
      pages: 1,
      spaceInterval: ""
    };
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.spaceInterval);
    next();
  },
  created() {
    this.spaceInterval = setInterval(() => {
      this.refetchSpaces();
    }, 30000);
  },
  methods: {
    ...mapActions("dashboard", ["retrieveTestspaces", "retrieveCompetitions"]),
    newPage(page) {
      this.pages = page;
      let newend = this.intervalnum * page;

      if (newend < this.endss) {
        this.endnum = newend;
        this.startnum = newend - this.intervalnum;
      } else {
        this.endnum = this.endss;
        this.startnum = newend - this.intervalnum;
      }
    },
    refetchSpaces() {
      this.$route.query.type == 'competition' ? this.retrieveCompetitions() : this.retrieveTestspaces();
    }
  },

  computed: {
    ...mapState({
      testspacesarray: state => state.dashboard.allorgspaces.data,
      orgspacesfetched: state => state.dashboard.orgspacesfetched
    }),

    usetestspacesarray() {
      return this.testspacesarray.slice(this.startnum, this.endnum);
    },
    endss() {
      let end = this.testspacesarray.length;
      return end;
    },
    ranger() {
      let ranger = Math.ceil(this.testspacesarray.length / this.intervalnum);
      return ranger;
    },
    retrieving() {
      //let trid = this.$route.params.trackid;

      let curres = this.testspacesarray.length;
      //this.result = curres;

      if (curres <= 0) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.allrewr {
  min-height: 70vh;
  background-color: white;
  border-radius: 20px 20px;
}

.list-heads {
  background-color: #00984a;
  color: white;
  border-radius: 5px 5px;
  font-weight: bold;
  display: flex;
  flex-flow: row wrap;
}

.viewmore {
  background-color: rgb(241, 234, 234);
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px auto;
  box-shadow: 5px 5px 15px black;
  cursor: pointer;
}

.maxres {
  border-radius: 5px 5px;
}

.maxres:hover {
  background-color: #eeeeee;
}

.vmore {
  margin: 5px;
  padding: 10px;
}

.spinver {
  width: 7rem;
  height: 7rem;
}
.head-p {
  width: 15%;
  padding: 2px;
}

.page-buttons {
  width: 35px;
  height: 35px;
}
.active-page-btn {
  background-color: #00377b;
  color: white;
}
.button-pager-group {
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: thin;
}

@media screen and (max-width: 999px) {
  .head-p {
    font-size: 0.6rem;
  }
  .page-buttons {
    width: 25px;
    height: 25px;
    padding: 0px 0px 0px 5px;
  }
}
</style>
